var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_1495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80123 12.0195L0.45611 2.67412C-0.152056 2.06624 -0.152056 1.08338 0.45611 0.475502C1.06399 -0.132378 2.04685 -0.132378 2.65473 0.475502L12.0001 9.82091L21.3453 0.475502C21.9534 -0.132378 22.936 -0.132378 23.5439 0.475502C24.152 1.08338 24.152 2.06624 23.5439 2.67412L14.1988 12.0195L23.5439 21.3649C24.152 21.9728 24.152 22.9557 23.5439 23.5636C23.2409 23.8668 22.8426 24.0191 22.4446 24.0191C22.0465 24.0191 21.6485 23.8668 21.3453 23.5636L12.0001 14.2181L2.65473 23.5636C2.3515 23.8668 1.95346 24.0191 1.55542 24.0191C1.15738 24.0191 0.759338 23.8668 0.45611 23.5636C-0.152056 22.9557 -0.152056 21.9728 0.45611 21.3649L9.80123 12.0195Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_1495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 -0.00012207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.678a47ddaff3d34c3f07dcb1bd585e51.svg";
export { ForwardRef as ReactComponent };